import { cn } from '@/lib/utils'

import { Button } from '../button'

interface CardHeaderProps {
  title: string
  content: string | string[]
  textColor?: string
  button?: {
    buttonText: string
    buttonVariant: 'primary' | 'secondary' | 'tertiary' | 'ghost'
    href: string
    buttonTextColor: string
  }
}

export function CardHeader({
  title,
  content,
  textColor,
  button
}: CardHeaderProps) {
  return (
    <div className="flex max-w-116 flex-col gap-3 md:gap-4 lg:px-10">
      <h2
        className={cn('text-heading-5 md:text-heading-4 font-bold', textColor)}
      >
        {title}
      </h2>
      {Array.isArray(content) ? (
        content.map((item, index) => (
          <p key={index} className="text-body-3 leading-relaxed">
            {item}
          </p>
        ))
      ) : (
        <p className="text-body-3 leading-relaxed">{content}</p>
      )}
      {button && (
        <Button
          label={button.buttonText}
          variant={button.buttonVariant}
          href={button.href}
          className={cn('mx-auto my-4 w-fit md:mx-0', button.buttonTextColor)}
        />
      )}
    </div>
  )
}
